export default {
  descricao: '',
}